import { useState, useCallback } from "react";

export const useApi = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const execute = useCallback(async (apiFn) => {
        setLoading(true);
        setError(null);

        const result = await apiFn(); 

        setLoading(false);

        if (result.success) {
            setData(result.data);
        } else {
            setError(result.error);
        }

        return result;
    }, []);

    const reset = useCallback(() => {
        setData(null);
        setError(null);
    }, []);

    return { data, loading, error, execute, reset };
};